/**
 * Error type identifiers used in log entry context to classify unhandled errors.
 * These values are set by global error handlers and checked by adapters
 * to determine whether a log entry should be captured as an exception.
 */
export const UNHANDLED_ERROR_TYPES = {
  UNCAUGHT_EXCEPTION: 'uncaughtException',
  UNHANDLED_REJECTION: 'unhandledRejection',
  ERROR_EVENT: 'errorEvent',
  REACT_ERROR_BOUNDARY: 'reactErrorBoundary',
} as const;
